module.exports = __webpack_public_path__ + "28bdc3ecc654c010cc72569d1b70b127.png";